import {
	Button,
	Dialog,
	Dropdown,
	DialogBody,
	DialogSurface,
	DialogContent,
	DialogActions,
	Label,
	Input,
	Option,
	makeStyles,
	DialogOpenChangeEvent,
	DialogOpenChangeData,
	SelectionEvents,
	OptionOnSelectData
} from '@fluentui/react-components';
import { SetStateAction, useState } from 'react';
import { useAddPlayerSocialMutation } from '../Api/Players/playersSlice';
import { useFetchSocialPlatformsQuery } from '../Api/Socials/socialSlice';

const useStyles = makeStyles({
	form: {
		display: 'flex',
		flexDirection: 'column',
		rowGap: '12px'
	}
});

export interface AddSocialDialogProps {
	isOpen: boolean;
	setIsOpen: React.Dispatch<SetStateAction<boolean>>;
	username: string;
}

const AddSocialDialog = (props: AddSocialDialogProps) => {
	const styles = useStyles();
	const [socialPlatform, setSocialPlatform] = useState(0);
	const [socialUsername, setSocialUsername] = useState('');
	const { data: socialPlatforms } = useFetchSocialPlatformsQuery(undefined);
	const [addSocialPlatform] = useAddPlayerSocialMutation();

	const onSaveClick = () => {
		void addSocialPlatform({
			id: socialPlatform,
			socialUsername: socialUsername,
			username: props.username
		});
		props.setIsOpen(false);
	};

	return (
		<Dialog
			open={props.isOpen}
			onOpenChange={(
				_event: DialogOpenChangeEvent,
				data: DialogOpenChangeData
			) => {
				props.setIsOpen(data.open);
			}}
		>
			<DialogSurface>
				<DialogBody>
					<DialogContent>
						<div className={styles.form}>
							<Label htmlFor='socialPlatform'>Platform</Label>
							<Dropdown
								id='socialPlatform'
								appearance='underline'
								onOptionSelect={(
									_event: SelectionEvents,
									data: OptionOnSelectData
								) => {
									setSocialPlatform(Number(data.optionValue));
								}}
							>
								{socialPlatforms &&
									socialPlatforms.map((item) => (
										<Option
											key={item.name}
											value={String(item.id)}
										>
											{item.name}
										</Option>
									))}
							</Dropdown>

							<Label htmlFor='socialUsername'>Username</Label>
							<Input
								id='socialUsername'
								type='text'
								appearance='underline'
								disabled={socialPlatform === 0}
								value={socialUsername}
								onChange={(event) => {
									setSocialUsername(event.target.value);
								}}
							/>
						</div>
					</DialogContent>
					<DialogActions>
						<Button
							type='button'
							appearance='secondary'
							onClick={() => {
								props.setIsOpen(false);
							}}
						>
							Cancel
						</Button>
						<Button
							type='button'
							appearance='primary'
							onClick={onSaveClick}
							disabled={
								socialPlatform === 0 || socialUsername === ''
							}
						>
							Save
						</Button>
					</DialogActions>
				</DialogBody>
			</DialogSurface>
		</Dialog>
	);
};

export default AddSocialDialog;
